import { render, staticRenderFns } from "./VueError.vue?vue&type=template&id=731bcb64&scoped=true&"
import script from "./VueError.vue?vue&type=script&lang=ts&"
export * from "./VueError.vue?vue&type=script&lang=ts&"
import style0 from "./VueError.vue?vue&type=style&index=0&id=731bcb64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731bcb64",
  null
  
)

export default component.exports